class Store {
    constructor(data) {
        this.raw = data;
    }

    getDataObject(key) {
        const tokens = key.split('/');
        let data = this.raw;
        let obj = null;
        let token = tokens.shift();

        while (token) {
            obj = data;
            data = data[token];

            if (typeof data !== 'undefined') {
                token = tokens.shift();
            } else {
                token = null;
                data = null;
            }
        }

        return {
            obj,
            data
        };
    }

    get(key, criteria) {
        const {data} = this.getDataObject(key);

        if (data === null) {
            console.error('No data for key: ', key);
        }

        const filter = data.$filter;
        let val = null;

        if (filter) {
            val = data[criteria] || data.$default;
        } else {
            val = data;
        }

        if (typeof val === 'object' && typeof data.$base !== 'undefined') {
            val = {
                ...data.$base,
                ...val
            };
        }

        return val;
    }

    set(key, value, criteria) {
        const {obj} = this.getDataObject(key);

        if (obj === null) {
            console.error('No object for key: ', key);
        }

        const filter = obj.$filter;

        if (filter) {
            obj[key][criteria[filter]] = value;
        } else {
            obj[key] = value;
        }

        return value;
    }
}

export default Store;
